import { NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-slide-up-popup',
    standalone: true,
    imports: [NgIf],
    templateUrl: './SlideInPopup.component.html',
})
export class SlideUpPopupComponent {
    @Input() isVisible: boolean = false; // Controls visibility
    @Output() closed = new EventEmitter<void>();

    closePopup() {
        this.isVisible = false;
        this.closed.emit();
    }
}
